import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

export class CaseConverter {
  specialCases: Record<string, string>;
  ignoreKeys: string[];

  constructor(
    specialCases: Record<string, string> = {},
    ignoreKeys: string[] = [],
  ) {
    this.specialCases = specialCases;
    this.ignoreKeys = ignoreKeys;
  }

  private handleSpecialCases = (
    obj: Record<string, any>,
    cases: Record<string, string>,
  ): object => {
    if (obj && typeof obj === "object") {
      if (!Array.isArray(obj)) {
        // object
        const oldKeys = Object.keys(obj);
        oldKeys.forEach((oldKey) => {
          const newKey = cases[oldKey];
          if (newKey && newKey !== oldKey) {
            Object.defineProperty(
              obj,
              newKey,
              Object.getOwnPropertyDescriptor(obj, oldKey)!,
            );
            delete obj[oldKey];
            obj[newKey] = this.handleSpecialCases(obj[newKey], cases);
          } else {
            obj[oldKey] = this.handleSpecialCases(obj[oldKey], cases);
          }
        });
      } else {
        // array
        return obj.map((element) => this.handleSpecialCases(element, cases));
      }
    }
    return obj;
  };

  public toSnake = (
    obj: object,
    ignoreKeys: string[] = [],
    specialCases: Record<string, string> = {},
  ) => {
    if (!obj) return obj;

    return snakecaseKeys(
      this.handleSpecialCases(obj, {
        ...this.specialCases,
        ...specialCases,
      }) as Record<string, unknown>,
      {
        exclude: [...this.ignoreKeys, ...ignoreKeys],
        deep: true,
      },
    );
  };

  public toCamel = (
    obj: object,
    ignoreKeys: string[] = [],
    specialCases: Record<string, string> = {},
  ) => {
    if (!obj) return obj;
    return camelcaseKeys(
      this.handleSpecialCases(obj, {
        ...this.specialCases,
        ...specialCases,
      }) as Record<string, unknown>,
      {
        exclude: [...this.ignoreKeys, ...ignoreKeys],
        deep: true,
      },
    );
  };

  public stringToSnake = (data: string) => {
    const result = snakecaseKeys({ [data]: null });
    return Object.keys(result)[0];
  };

  public stringToCamel = (data: string) => {
    const result = camelcaseKeys({ [data]: null });
    return Object.keys(result)[0];
  };
}
